module.exports = __webpack_public_path__ + "static/media/cdb19.ef19c605.png";